module.exports = __webpack_public_path__ + "assets/d61019802f2988949d1a8c64a84b062e.png";